import apiClient from "../http/apiClient";
import { GROOMING_ENDPOINTS } from "../http/endpoints";

const appointmentUrl = (id) => `${GROOMING_ENDPOINTS.appointments}${id}/`;
const appointmentConvertToOrderUrl = (id) => `${appointmentUrl(id)}convert-to-order/`;
const petUrl = (id) => `${GROOMING_ENDPOINTS.pets}${id}/`;
const serviceTypeUrl = (id) => `${GROOMING_ENDPOINTS.serviceTypes}${id}/`;
const orderUrl = (id) => `${GROOMING_ENDPOINTS.orders}${id}/`;
const orderAssessmentUrl = (id) => `${orderUrl(id)}assessment/`;
const orderNotesUrl = (id) => `${orderUrl(id)}notes/`;
const orderNoteUrl = (id, noteId) => `${orderNotesUrl(id)}${noteId}/`;
const orderLinesUrl = (id) => `${orderUrl(id)}lines/`;
const orderLineUrl = (id, lineId) => `${orderLinesUrl(id)}${lineId}/`;
const orderCheckInUrl = (id) => `${orderUrl(id)}check-in/`;
const orderStartUrl = (id) => `${orderUrl(id)}start/`;
const orderReadyUrl = (id) => `${orderUrl(id)}ready/`;
const orderDeliverUrl = (id) => `${orderUrl(id)}deliver/`;
const orderCancelUrl = (id) => `${orderUrl(id)}cancel/`;
const orderConvertToSaleUrl = (id) => `${orderUrl(id)}convert-to-sale/`;

export async function listAppointments(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.appointments, { params });
  return response.data;
}

export async function getAppointmentContext(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.appointmentContext, { params });
  return response.data;
}

export async function getBusinessConfig(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.config, { params });
  return response.data;
}

export async function updateBusinessConfig(payload = {}) {
  const response = await apiClient.patch(GROOMING_ENDPOINTS.config, payload);
  return response.data;
}

export async function getAppointmentAvailability(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.appointmentAvailability, { params });
  return response.data;
}

export async function createAppointment(payload = {}) {
  const response = await apiClient.post(GROOMING_ENDPOINTS.appointments, payload);
  return response.data;
}

export async function getAppointment(id, params = {}) {
  const response = await apiClient.get(appointmentUrl(id), { params });
  return response.data;
}

export async function updateAppointment(id, payload = {}) {
  const response = await apiClient.patch(appointmentUrl(id), payload);
  return response.data;
}

export async function lookupCustomerByPhone(phoneNumber, params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.customerLookupByPhone, {
    params: {
      phone_number: phoneNumber,
      ...params,
    },
  });
  return response.data;
}

export async function createQuickCustomer(payload = {}) {
  const response = await apiClient.post(GROOMING_ENDPOINTS.customerQuickCreate, payload);
  return response.data;
}

export async function createPet(payload = {}) {
  const response = await apiClient.post(GROOMING_ENDPOINTS.pets, payload);
  return response.data;
}

export async function listCustomerPets(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.pets, { params });
  return response.data;
}

export async function updatePet(id, payload = {}) {
  const response = await apiClient.patch(petUrl(id), payload);
  return response.data;
}

export async function listServiceTypes(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.serviceTypes, { params });
  return response.data;
}

export async function createServiceType(payload = {}) {
  const response = await apiClient.post(GROOMING_ENDPOINTS.serviceTypes, payload);
  return response.data;
}

export async function updateServiceType(id, payload = {}) {
  const response = await apiClient.patch(serviceTypeUrl(id), payload);
  return response.data;
}

export async function convertAppointmentToOrder(id, payload = {}) {
  const response = await apiClient.post(appointmentConvertToOrderUrl(id), payload);
  return response.data;
}

export async function listOrders(params = {}) {
  const response = await apiClient.get(GROOMING_ENDPOINTS.orders, { params });
  return response.data;
}

export async function getOrder(id, params = {}) {
  const response = await apiClient.get(orderUrl(id), { params });
  return response.data;
}

export async function updateOrder(id, payload = {}) {
  const response = await apiClient.patch(orderUrl(id), payload);
  return response.data;
}

export async function checkInOrder(id, payload = {}) {
  const response = await apiClient.post(orderCheckInUrl(id), payload);
  return response.data;
}

export async function startOrder(id, payload = {}) {
  const response = await apiClient.post(orderStartUrl(id), payload);
  return response.data;
}

export async function readyOrder(id, payload = {}) {
  const response = await apiClient.post(orderReadyUrl(id), payload);
  return response.data;
}

export async function deliverOrder(id, payload = {}) {
  const response = await apiClient.post(orderDeliverUrl(id), payload);
  return response.data;
}

export async function cancelOrder(id, payload = {}) {
  const response = await apiClient.post(orderCancelUrl(id), payload);
  return response.data;
}

export async function convertOrderToSale(id, payload = {}) {
  const response = await apiClient.post(orderConvertToSaleUrl(id), payload);
  return response.data;
}

export async function listOrderLines(id, params = {}) {
  const response = await apiClient.get(orderLinesUrl(id), { params });
  return response.data;
}

export async function createOrderLine(id, payload = {}) {
  const response = await apiClient.post(orderLinesUrl(id), payload);
  return response.data;
}

export async function updateOrderLine(id, lineId, payload = {}) {
  const response = await apiClient.patch(orderLineUrl(id, lineId), payload);
  return response.data;
}

export async function deleteOrderLine(id, lineId, branchId, extraParams = {}) {
  const response = await apiClient.delete(orderLineUrl(id, lineId), {
    params: {
      branch_id: branchId,
      ...extraParams,
    },
  });
  return response.data;
}

export async function getOrderAssessment(id, params = {}) {
  const response = await apiClient.get(orderAssessmentUrl(id), { params });
  return response.data;
}

export async function saveOrderAssessment(id, payload = {}) {
  const response = await apiClient.post(orderAssessmentUrl(id), payload);
  return response.data;
}

export async function listOrderNotes(id, params = {}) {
  const response = await apiClient.get(orderNotesUrl(id), { params });
  return response.data;
}

export async function createOrderNote(id, payload = {}) {
  const response = await apiClient.post(orderNotesUrl(id), payload);
  return response.data;
}

export async function updateOrderNote(id, noteId, payload = {}) {
  const response = await apiClient.patch(orderNoteUrl(id, noteId), payload);
  return response.data;
}

export const groomingService = {
  listAppointments,
  getAppointmentContext,
  getBusinessConfig,
  updateBusinessConfig,
  getAppointmentAvailability,
  createAppointment,
  getAppointment,
  updateAppointment,
  lookupCustomerByPhone,
  createQuickCustomer,
  createPet,
  listCustomerPets,
  updatePet,
  listServiceTypes,
  createServiceType,
  updateServiceType,
  convertAppointmentToOrder,
  listOrders,
  getOrder,
  updateOrder,
  checkInOrder,
  startOrder,
  readyOrder,
  deliverOrder,
  cancelOrder,
  convertOrderToSale,
  listOrderLines,
  createOrderLine,
  updateOrderLine,
  deleteOrderLine,
  getOrderAssessment,
  saveOrderAssessment,
  listOrderNotes,
  createOrderNote,
  updateOrderNote,
};

export default groomingService;
